export type GoogleLogoProps = {
  disabled?: boolean;
};

export const GoogleLogo = ({ disabled }: GoogleLogoProps) => (
  <svg width={23} height={23} fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>google logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.723 11.696c0-.612-.055-1.2-.157-1.764h-8.123v3.336h4.641a3.967 3.967 0 0 1-1.72 2.603v2.164h2.787c1.63-1.501 2.572-3.712 2.572-6.339Z"
      fill={disabled ? '#A5AAAF' : '#4285F4'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.443 20.125c2.328 0 4.28-.772 5.708-2.09l-2.788-2.164c-.772.518-1.76.824-2.92.824-2.247 0-4.148-1.518-4.827-3.556H3.735v2.234a8.622 8.622 0 0 0 7.708 4.752Z"
      fill={disabled ? '#A5AAAF' : '#34A853'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.616 13.139a5.185 5.185 0 0 1-.27-1.64c0-.568.098-1.12.27-1.638V7.627H3.735a8.622 8.622 0 0 0-.917 3.873c0 1.392.333 2.709.917 3.873l2.881-2.234Z"
      fill={disabled ? '#A5AAAF' : '#FBBC05'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.443 6.305c1.266 0 2.403.436 3.297 1.29l2.473-2.474c-1.493-1.391-3.446-2.246-5.77-2.246a8.622 8.622 0 0 0-7.708 4.752L6.616 9.86c.679-2.038 2.58-3.556 4.827-3.556Z"
      fill={disabled ? '#A5AAAF' : '#EA4335'}
    />
  </svg>
);
